import { OnsiteEditDto } from "@intelligems/ig-types/dtos/onsite-edits";
import { VariationDto } from "@intelligems/ig-types/dtos/variations";

export const getOnsiteEditsFromExperienceDto = (variations: VariationDto[]) => {
  const tempEdits: OnsiteEditDto[] = [];
  for (const variation of variations) {
    for (const edit of variation.onsiteEdits ?? []) {
      tempEdits.push(edit);
    }
  }
  return tempEdits;
};
